import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'mt-search',
    templateUrl: './search.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent implements OnInit {
  @Input() label: string = "";
  @Input() list: any = [];
  @Input() disabled: boolean = false;
  @Input() model?: string;
  @Input() required?: boolean | false;
  @Input() placeholder: string = 'Enter Text';
  @Input() class: string ="";
  @Output() onSearch = new EventEmitter<any>();
  private subject: Subject<string> = new Subject();
  private subscriptions = new Subscription();
  options: any = [];
  constructor() {}

  ngOnInit() {
    this.subscriptions.add(this.subject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTextValue => {
    this.onSearch.emit(searchTextValue);
    }));
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }

  onModelChange($event: any) {
    const value = $event.toLowerCase();
    if (this.list && this.list.length > 0) {
      this.options = this.list.filter((option: any) => option.toLowerCase().includes(value));
    }
  }
  search($event: any) {
    if($event.keyCode === 13 ) {
      // this.subject.next(this.model);
      this.onSearch.emit(this.model);
    }
  }
  clear() {
    this.model = '';
    this.onSearch.emit(this.model);
  }
}
